var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.9976 7.43906C17.9376 7.42906 17.8676 7.42906 17.8076 7.43906C16.4276 7.38906 15.3276 6.25905 15.3276 4.85905C15.3276 3.42905 16.4776 2.27905 17.9076 2.27905C19.3376 2.27905 20.4876 3.43905 20.4876 4.85905C20.4776 6.25905 19.3776 7.38906 17.9976 7.43906Z",
    stroke: "#484954",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.9675 14.7191C18.3375 14.9491 19.8475 14.7091 20.9075 13.9991C22.3175 13.0591 22.3175 11.5191 20.9075 10.5791C19.8375 9.86909 18.3075 9.62909 16.9375 9.86909",
    stroke: "#484954",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.96754 7.43906C6.02754 7.42906 6.09754 7.42906 6.15754 7.43906C7.53754 7.38906 8.63754 6.25905 8.63754 4.85905C8.63754 3.42905 7.48754 2.27905 6.05754 2.27905C4.62754 2.27905 3.47754 3.43905 3.47754 4.85905C3.48754 6.25905 4.58754 7.38906 5.96754 7.43906Z",
    stroke: "#484954",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.9975 14.7191C5.6275 14.9491 4.1175 14.7091 3.0575 13.9991C1.6475 13.0591 1.6475 11.5191 3.0575 10.5791C4.1275 9.86909 5.6575 9.62909 7.0275 9.86909",
    stroke: "#484954",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 14.909C11.9401 14.899 11.8701 14.899 11.8101 14.909C10.4301 14.859 9.33008 13.729 9.33008 12.329C9.33008 10.899 10.4801 9.74902 11.9101 9.74902C13.3401 9.74902 14.4901 10.909 14.4901 12.329C14.4801 13.729 13.3801 14.869 12.0001 14.909Z",
    stroke: "#484954",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08997 18.059C7.67997 18.999 7.67997 20.539 9.08997 21.479C10.69 22.549 13.31 22.549 14.91 21.479C16.32 20.539 16.32 18.999 14.91 18.059C13.32 16.999 10.69 16.999 9.08997 18.059Z",
    stroke: "#484954",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.f69a8d38929768942c963e010c9bb6cc.svg";
export { ForwardRef as ReactComponent };